import React from "react";
import styled from "styled-components";
import { Btn, ButtonGroup } from "components/Layout";

// 🧱 Base section
const HeroSection = styled.section.withConfig({
  shouldForwardProp: (prop) => prop !== "bgImage"
})`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100vh;
  background-color: black; /* fallback for slow-loading videos/images */

  ${({ bgImage }) =>
    bgImage &&
    `
    background-image: url(${bgImage});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  `}

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1;
  }
`;

// 🧱 Optional video background
const VideoBackground = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  width: auto;
  min-width: 100vw;
  min-height: 100vh;
  transform: translate(-50%, -50%);
  object-fit: cover;
  z-index: 0;
  pointer-events: none;
`;

// 🧱 Hero content container
const HeroContent = styled.div`
  position: relative; /* relative to section */
  z-index: 2;
  text-align: center;
`;

const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.xxl};
  color: ${({ theme }) => theme.colors.secondary};

  @media (max-width: ${({ theme }) => theme.phoneWidth}) {
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

const Subtitle = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.phoneWidth}) {
    font-size: ${({ theme }) => theme.fontSizes.md};
  }
`;

export default function Hero({ title, subtitle, buttons, bgImage, videoSrc }) {
  return (
    <HeroSection bgImage={videoSrc ? undefined : bgImage}>
      {/* 🎥 Video background (only render if provided) */}
      {videoSrc && (
        <VideoBackground
          autoPlay
          muted
          loop
          playsInline
          src={videoSrc}
          type="video/mp4"
        />
      )}

      <HeroContent>
        {title && <Title>{title}</Title>}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}

        {buttons && (
          <ButtonGroup>
            {buttons.map((button, i) => (
              <Btn
                key={i}
                type={button.type}
                size={button.size || "medium"}
                onClick={button.onClick}
              >
                {button.label}
              </Btn>
            ))}
          </ButtonGroup>
        )}
      </HeroContent>
    </HeroSection>
  );
};
